
import Vue from 'vue'

const DEFAULT_GSC_CONNECT_URL = 'https://api.ari.company/api/gsc/connect'
const DEFAULT_GSC_API_BASE = 'https://api.ari.company/api/gsc'
const DEFAULT_ARI_PULSE_SUBSCRIBE_URL = 'https://api.ari.company/api/form/ari-pulse-subscribe'
const DEFAULT_ARI_PULSE_FEEDBACK_URL = 'https://api.ari.company/api/form/ari-pulse-feedback'
const OLEH_PORTRAIT = require('@/assets/img/ari-pulse/oleh-dankevych.webp')

export default Vue.extend({
  name: 'GscSnapshotPage',

  data () {
    return {
      connectUrl: (process.env.VUE_APP_GSC_CONNECT_URL as string) || DEFAULT_GSC_CONNECT_URL,
      gscApiBase: (process.env.VUE_APP_GSC_API_BASE as string) || DEFAULT_GSC_API_BASE,
      ariPulseSubscribeUrl:
        (process.env.VUE_APP_ARI_PULSE_SUBSCRIBE_URL as string) || DEFAULT_ARI_PULSE_SUBSCRIBE_URL,
      ariPulseFeedbackUrl:
        (process.env.VUE_APP_ARI_PULSE_FEEDBACK_URL as string) || DEFAULT_ARI_PULSE_FEEDBACK_URL,
      olehPortrait: OLEH_PORTRAIT,
      gscSessionId: '',
      gscProperties: [] as Array<{ site_url: string, permission_level: string }>,
      selectedProperty: '',
      gscMode: 'rolling' as 'rolling' | 'iso_week' | 'month_to_month',
      gscSearchType: 'web' as 'web' | 'image' | 'video' | 'news' | 'all',
      gscDays: 7,
      gscDailyDays: 28,
      gscIsoYear: new Date().getUTCFullYear(),
      gscIsoWeek: 1,
      gscIsoYearOptions: [] as number[],
      gscIsoWeekOptions: Array.from({ length: 53 }, (_, index) => index + 1),
      gscMonthYear: new Date().getUTCFullYear(),
      gscMonth: new Date().getUTCMonth() + 1,
      gscMonthYearOptions: [] as number[],
      gscMonthOptions: [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' }
      ] as Array<{ value: number, label: string }>,
      gscComparePrevious: true,
      gscOverview: null as any,
      gscLoadingProperties: false,
      gscLoadingOverview: false,
      gscExporting: false,
      gscError: '',
      gscNotice: '',
      gscPeriodsLabel: '',
      isSubscribeFormVisible: false,
      isSubscribeSubmitting: false,
      isSubscribed: false,
      subscribeEmail: '',
      subscribeError: '',
      pulseFeedbackPresetOptions: [
        'Thank you, very useful',
        'Great clarity and structure',
        'Good baseline, needs deeper insights',
        'Useful export, please expand functionality'
      ] as string[],
      pulseFeedbackPreset: 'Thank you, very useful',
      pulseFeedbackRating: 3,
      pulseFeedbackContinue: 'Yes',
      pulseFeedbackText: '',
      pulseFeedbackIdeas: '',
      pulseFeedbackSubmitting: false,
      pulseFeedbackSuccess: false,
      pulseFeedbackError: ''
    }
  },

  mounted () {
    this.initializeIsoDefaults()
    this.initializeMonthDefaults()
    this.bootstrapGscLiveMode()
  },

  methods: {
    isoWeekFromDate (date: Date) {
      const utcDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()))
      const day = utcDate.getUTCDay() || 7
      utcDate.setUTCDate(utcDate.getUTCDate() + 4 - day)
      const isoYear = utcDate.getUTCFullYear()
      const yearStart = new Date(Date.UTC(isoYear, 0, 1))
      const week = Math.ceil((((utcDate.getTime() - yearStart.getTime()) / 86400000) + 1) / 7)
      return { year: isoYear, week }
    },
    initializeIsoDefaults () {
      const anchorDate = new Date()
      anchorDate.setUTCDate(anchorDate.getUTCDate() - 2)
      const iso = this.isoWeekFromDate(anchorDate)
      this.gscIsoYear = iso.year
      this.gscIsoWeek = iso.week
      this.gscIsoYearOptions = [iso.year, iso.year - 1, iso.year - 2, iso.year + 1]
    },
    initializeMonthDefaults () {
      const anchorDate = new Date()
      anchorDate.setUTCDate(anchorDate.getUTCDate() - 2)
      this.gscMonthYear = anchorDate.getUTCFullYear()
      this.gscMonth = anchorDate.getUTCMonth() + 1
      this.gscMonthYearOptions = [
        this.gscMonthYear,
        this.gscMonthYear - 1,
        this.gscMonthYear - 2,
        this.gscMonthYear + 1
      ]
    },
    buildConnectUrl (): string {
      try {
        const connectUrl = new URL(this.connectUrl)
        const returnTo = `${window.location.origin}${window.location.pathname}`
        connectUrl.searchParams.set('return_to', returnTo)
        return connectUrl.toString()
      } catch (error) {
        return this.connectUrl
      }
    },
    connectGsc () {
      window.location.href = this.buildConnectUrl()
    },
    async bootstrapGscLiveMode () {
      const url = new URL(window.location.href)
      const gscSession = (url.searchParams.get('gsc_session') || '').trim()
      const gscError = (url.searchParams.get('gsc_error') || '').trim()
      const gscConnected = (url.searchParams.get('gsc_connected') || '').trim()

      if (gscSession) {
        this.gscSessionId = gscSession
        this.gscNotice = 'Google Search Console connected. Loading live workspace...'
      }

      if (gscError) {
        this.gscError = `Google connection failed: ${gscError}. Please try again.`
      }

      if (gscSession || gscError || gscConnected) {
        url.searchParams.delete('gsc_session')
        url.searchParams.delete('gsc_error')
        url.searchParams.delete('gsc_connected')
        const cleanUrl = `${url.pathname}${url.search}${url.hash}`
        window.history.replaceState({}, document.title, cleanUrl)
      }

      if (!this.gscSessionId) {
        return
      }

      try {
        const statusPayload = await this.gscGet('/status')
        if (!statusPayload.connected) {
          this.gscSessionId = ''
          this.gscError = 'Your live session has expired. Please reconnect.'
          return
        }

        await this.loadLiveProperties()
        if (this.selectedProperty) {
          await this.loadLiveOverview()
        }
      } catch (error) {
        console.error(error)
        this.gscSessionId = ''
        this.gscError = 'Live session check failed. Please reconnect.'
      }
    },
    async parseApiResponse (response: Response): Promise<any> {
      let payload: any = null
      try {
        payload = await response.json()
      } catch (error) {
        payload = null
      }

      if (!response.ok) {
        const fallback = `Request failed (${response.status})`
        const message = payload && (payload.message || payload.error)
          ? String(payload.message || payload.error)
          : fallback
        throw new Error(message)
      }

      return payload || {}
    },
    async gscGet (path: string, params: Record<string, string | number> = {}) {
      const endpoint = new URL(`${this.gscApiBase}${path}`)
      Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
          return
        }
        endpoint.searchParams.set(key, String(value))
      })

      const headers: Record<string, string> = {}
      if (this.gscSessionId) {
        headers['X-GSC-Session'] = this.gscSessionId
      }

      const response = await fetch(endpoint.toString(), {
        method: 'GET',
        headers
      })

      return this.parseApiResponse(response)
    },
    async gscPost (path: string) {
      const endpoint = `${this.gscApiBase}${path}`
      const headers: Record<string, string> = {
        'Content-Type': 'application/json'
      }
      if (this.gscSessionId) {
        headers['X-GSC-Session'] = this.gscSessionId
      }

      const response = await fetch(endpoint, {
        method: 'POST',
        headers,
        body: JSON.stringify({})
      })

      return this.parseApiResponse(response)
    },
    async loadLiveProperties () {
      if (!this.gscSessionId) {
        return
      }
      this.gscLoadingProperties = true
      this.gscError = ''

      try {
        const payload = await this.gscGet('/properties')
        this.gscProperties = Array.isArray(payload.properties) ? payload.properties : []

        if (!this.gscProperties.length) {
          this.gscError = 'No accessible Search Console properties were found for this account.'
          return
        }

        const hasSelected = this.gscProperties.some((item) => item.site_url === this.selectedProperty)
        if (!hasSelected) {
          this.selectedProperty = this.gscProperties[0].site_url
        }
      } catch (error) {
        console.error(error)
        this.gscError = 'Failed to load Search Console properties.'
      } finally {
        this.gscLoadingProperties = false
      }
    },
    buildPeriodsLabel (periods: any): string {
      const currentPeriod = periods && periods.current ? periods.current : null
      const previousPeriod = periods && periods.previous ? periods.previous : null
      const currentMonth = currentPeriod && currentPeriod.month_label ? ` (${currentPeriod.month_label})` : ''
      const previousMonth = previousPeriod && previousPeriod.month_label ? ` (${previousPeriod.month_label})` : ''
      if (!currentPeriod || !previousPeriod) {
        if (!currentPeriod) {
          return ''
        }
        return `Current: ${currentPeriod.start} to ${currentPeriod.end}${currentMonth} | Comparison disabled`
      }
      const currentIso = currentPeriod.iso_year && currentPeriod.iso_week
        ? ` (ISO week ${currentPeriod.iso_week}, ${currentPeriod.iso_year})`
        : ''
      const previousIso = previousPeriod.iso_year && previousPeriod.iso_week
        ? ` (ISO week ${previousPeriod.iso_week}, ${previousPeriod.iso_year})`
        : ''
      return `Current: ${currentPeriod.start} to ${currentPeriod.end}${currentIso}${currentMonth} | Previous: ${previousPeriod.start} to ${previousPeriod.end}${previousIso}${previousMonth}`
    },
    buildOverviewParams () {
      const params: Record<string, string | number> = {
        site_url: this.selectedProperty,
        limit: 12,
        mode: this.gscMode,
        compare_previous: this.gscComparePrevious ? 1 : 0,
        search_type: this.gscSearchType,
        daily_days: this.gscDailyDays
      }

      if (this.gscMode === 'iso_week') {
        params.iso_year = this.gscIsoYear
        params.iso_week = this.gscIsoWeek
      } else if (this.gscMode === 'month_to_month') {
        params.month_year = this.gscMonthYear
        params.month = this.gscMonth
      } else {
        params.days = this.gscDays
      }

      return params
    },
    async loadLiveOverview () {
      if (!this.gscSessionId || !this.selectedProperty) {
        return
      }

      this.gscLoadingOverview = true
      this.gscError = ''

      try {
        const payload = await this.gscGet('/overview', this.buildOverviewParams())
        this.gscOverview = payload
        this.gscPeriodsLabel = this.buildPeriodsLabel(payload.periods)
      } catch (error) {
        console.error(error)
        const details = error instanceof Error ? (error.message || '').trim() : ''
        this.gscError = details
          ? `Failed to load live overview data: ${details}`
          : 'Failed to load live overview data. Please reconnect and try again.'
      } finally {
        this.gscLoadingOverview = false
      }
    },
    async disconnectGsc () {
      try {
        if (this.gscSessionId) {
          await this.gscPost('/disconnect')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.gscSessionId = ''
        this.gscProperties = []
        this.selectedProperty = ''
        this.gscOverview = null
        this.gscPeriodsLabel = ''
        this.gscNotice = 'Session closed. Connect again to continue.'
      }
    },
    async exportLiveReport () {
      if (!this.gscSessionId || !this.selectedProperty || this.gscExporting) {
        return
      }

      this.gscExporting = true
      this.gscError = ''

      try {
        const endpoint = new URL(`${this.gscApiBase}/export`)
        const params = this.buildOverviewParams()
        Object.entries(params).forEach(([key, value]) => {
          endpoint.searchParams.set(key, String(value))
        })

        const response = await fetch(endpoint.toString(), {
          method: 'GET',
          headers: {
            'X-GSC-Session': this.gscSessionId
          }
        })

        if (!response.ok) {
          const payload = await response.json().catch(() => null)
          const message = payload && (payload.message || payload.error)
            ? String(payload.message || payload.error)
            : `Export failed (${response.status})`
          throw new Error(message)
        }

        const blob = await response.blob()
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        const disposition = response.headers.get('Content-Disposition') || ''
        const filenameMatch = disposition.match(/filename=\"?([^\";]+)\"?/i)
        const filename = filenameMatch && filenameMatch[1] ? filenameMatch[1] : 'ari-pulse-report.xlsx'
        link.href = downloadUrl
        link.download = filename
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(downloadUrl)
      } catch (error) {
        console.error(error)
        this.gscError = 'Failed to export Excel report. Please try again.'
      } finally {
        this.gscExporting = false
      }
    },
    formatInteger (value: number | null): string {
      if (value === null || value === undefined) {
        return '—'
      }
      const normalized = Number(value || 0)
      return normalized.toLocaleString('en-GB', {
        maximumFractionDigits: 0
      })
    },
    formatSigned (value: number | null, digits: number = 0): string {
      if (value === null || value === undefined) {
        return '—'
      }
      const normalized = Number(value || 0)
      const formatted = normalized.toLocaleString('en-GB', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      })
      return normalized > 0 ? `+${formatted}` : formatted
    },
    formatCtr (value: number | null): string {
      if (value === null || value === undefined) {
        return '—'
      }
      const normalized = Number(value || 0)
      return `${(normalized * 100).toFixed(2)}%`
    },
    formatPosition (value: number | null): string {
      if (value === null || value === undefined) {
        return '—'
      }
      const normalized = Number(value || 0)
      return normalized.toFixed(2)
    },
    deltaClass (value: number | null, inverseDirection: boolean = false): string {
      if (value === null || value === undefined) {
        return 'is-neutral'
      }
      const normalized = Number(value || 0)
      if (Math.abs(normalized) < 0.000001) {
        return 'is-neutral'
      }
      if (inverseDirection) {
        return normalized < 0 ? 'is-positive' : 'is-negative'
      }
      return normalized > 0 ? 'is-positive' : 'is-negative'
    },
    formatRatioPercent (value: number | null): string {
      if (value === null || value === undefined) {
        return '—'
      }
      const normalized = Number(value || 0) * 100
      return `${normalized.toFixed(2)}%`
    },
    buildPerformanceRows (data: any) {
      if (!data) {
        return []
      }
      return [
        {
          key: 'selected',
          label: 'Selected mode',
          cur: (data.selected_mode || {}).cur || {},
          prev: (data.selected_mode || {}).prev || {},
          delta: (data.selected_mode || {}).delta || {}
        },
        {
          key: 'w2w',
          label: 'W2W (7d vs previous 7d)',
          cur: (data.w2w || {}).cur || {},
          prev: (data.w2w || {}).prev || {},
          delta: (data.w2w || {}).delta || {}
        },
        {
          key: 'm2m',
          label: 'M2M (current month vs previous month)',
          cur: (data.m2m || {}).cur || {},
          prev: (data.m2m || {}).prev || {},
          delta: (data.m2m || {}).delta || {}
        }
      ]
    },
    positionBandClass (value: number | null): string {
      if (value === null || value === undefined || Number.isNaN(Number(value))) {
        return 'position-band position-band--none'
      }
      const normalized = Number(value)
      if (normalized <= 3) {
        return 'position-band position-band--p1-3'
      }
      if (normalized <= 10) {
        return 'position-band position-band--p4-10'
      }
      if (normalized <= 20) {
        return 'position-band position-band--p11-20'
      }
      if (normalized <= 50) {
        return 'position-band position-band--p21-50'
      }
      return 'position-band position-band--p51plus'
    },
    subscribeForUpdates () {
      if (this.isSubscribed) {
        return
      }
      this.subscribeError = ''
      this.isSubscribeFormVisible = !this.isSubscribeFormVisible
      if (this.isSubscribeFormVisible) {
        this.$nextTick(() => {
          const emailInput = this.$refs.subscribeEmailInput as HTMLInputElement | undefined
          if (emailInput) {
            emailInput.focus()
          }
        })
      }
    },
    isValidEmail (email: string): boolean {
      const normalizedEmail = (email || '').trim().toLowerCase()
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)
    },
    async submitAriPulseSubscription () {
      if (this.isSubscribeSubmitting) {
        return
      }

      const normalizedEmail = (this.subscribeEmail || '').trim().toLowerCase()
      if (!this.isValidEmail(normalizedEmail)) {
        this.subscribeError = 'Please enter a valid email address.'
        return
      }

      this.isSubscribeSubmitting = true
      this.subscribeError = ''

      try {
        const response = await fetch(this.ariPulseSubscribeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: normalizedEmail
          })
        })

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`)
        }

        this.isSubscribed = true
        this.isSubscribeFormVisible = false
        this.subscribeEmail = ''
      } catch (error) {
        console.error(error)
        this.subscribeError = 'Subscription could not be completed. Please try again.'
      } finally {
        this.isSubscribeSubmitting = false
      }
    },
    async submitAriPulseFeedback () {
      if (this.pulseFeedbackSubmitting) {
        return
      }

      if (!this.gscOverview) {
        this.pulseFeedbackError = 'Generate report data first, then send feedback.'
        return
      }

      this.pulseFeedbackSubmitting = true
      this.pulseFeedbackError = ''
      this.pulseFeedbackSuccess = false

      try {
        const response = await fetch(this.ariPulseFeedbackUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            rating: this.pulseFeedbackRating,
            quick_feedback: this.pulseFeedbackPreset,
            continue_development: this.pulseFeedbackContinue,
            feedback: this.pulseFeedbackText,
            ideas: this.pulseFeedbackIdeas,
            property: this.selectedProperty,
            mode: this.gscMode,
            period_label: this.gscPeriodsLabel,
            source: '/ari-pulse'
          })
        })

        if (!response.ok) {
          const payload = await response.json().catch(() => null)
          const message = payload && (payload.message || payload.error)
            ? String(payload.message || payload.error)
            : `Feedback failed (${response.status})`
          throw new Error(message)
        }

        this.pulseFeedbackSuccess = true
        this.pulseFeedbackText = ''
        this.pulseFeedbackIdeas = ''
      } catch (error) {
        console.error(error)
        this.pulseFeedbackError = 'Feedback could not be sent. Please try again.'
      } finally {
        this.pulseFeedbackSubmitting = false
      }
    },
    requestConsultation () {
      window.location.href = '/contact'
    },
    scrollToHowItWorks () {
      const section = document.getElementById('gsc-how-it-works')
      if (!section) {
        return
      }
      section.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
})
